export const getInstagramStoryUrl = ({
  username,
  externalLink,
}: {
  username: string
  externalLink: string | null
}): string | null => {
  if (!username) return null

  const storyMatch = externalLink?.match(
    /^https:\/\/(?:www\.)?instagram\.com\/stories\/([^/]+)\/(\d+)\/?(?:[?#].*)?$/,
  )
  const storyId =
    storyMatch?.[1]?.toLowerCase() === username.toLowerCase()
      ? storyMatch?.[2]
      : undefined

  return `https://www.instagram.com/stories/${encodeURIComponent(username)}/${storyId ?? ''}`
}
